import app from "../_app";

const variantPopup = document.querySelector('.js-variant-popup');

if (variantPopup) {
    const slider = variantPopup.querySelector('.js-slider');
    const triggers = [...document.querySelectorAll('.js-variant-popup-trigger')];
    const closeTriggers = [...document.querySelectorAll('.js-variant-popup-close')];

    const openvariantPopup = e => {
        const slideIndex = +e.currentTarget.dataset.index;
        slider.dispatchEvent(new CustomEvent('slider.goToSlide', { detail: { slideIndex } }));

        app.lockBody();
        variantPopup.setAttribute('data-open', '');
    };

    const closevariantPopup = () => {
        variantPopup.removeAttribute('data-open');
        app.unlockBody();
    };

    triggers.map(trigger => trigger.addEventListener('click', openvariantPopup));
    closeTriggers.map(trigger => trigger.addEventListener('click', closevariantPopup));
}
